import { Grid } from "@mui/material";
import { useCompanyFacts } from "../../../data/team/company/company";
import NWONTextWithImages from "../../02-molecules/NWONTextWithImages/NWONTextWithImages";
import { MediaPosition } from "../../02-molecules/NWONTextWithImages/NWONTextWithImagesInterfaces";
import NWONSection from "../NWONSection/NWONSection";
import { useNWONTeamDetailsStyles } from "./NWONTeamDetailsStyles";

const NWONTeamDetails = (): JSX.Element => {
  const facts = useCompanyFacts();
  const { classes } = useNWONTeamDetailsStyles();

  return (
    <NWONSection>
      <Grid container={true} className={classes.factsWrapper}>
        {facts.map((fact, index) => {
          return (
            <NWONTextWithImages
              key={`fact-${fact.title}`}
              title={fact.title}
              description={fact.description}
              illustration={fact.image}
              animation={fact.lottieAnimation}
              mediaPosition={
                index % 2 === 0 ? MediaPosition.Left : MediaPosition.Right
              }
            />
          );
        })}
      </Grid>
    </NWONSection>
  );
};

export default NWONTeamDetails;
